var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          directives: [{ name: "el-drag-dialog", rawName: "v-el-drag-dialog" }],
          attrs: {
            visible: _vm.innerVisible,
            title: _vm.title,
            width: "400px",
            "close-on-click-modal": false,
            "append-to-body": ""
          },
          on: {
            "update:visible": function($event) {
              _vm.innerVisible = $event
            }
          }
        },
        [
          _c(
            "div",
            {
              staticClass: "app-main-inner-row",
              staticStyle: { "padding-bottom": "10px" }
            },
            [
              _c(
                "el-form",
                { attrs: { "label-width": "100px", "label-position": "left" } },
                [
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Partners.doorName") } },
                    [
                      _c("el-input", {
                        attrs: { no: "name" },
                        model: {
                          value: _vm.siteInfo.name,
                          callback: function($$v) {
                            _vm.$set(_vm.siteInfo, "name", $$v)
                          },
                          expression: "siteInfo.name"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("Payment.contactPerson") } },
                    [
                      _c("el-input", {
                        attrs: { no: "contact" },
                        model: {
                          value: _vm.siteInfo.contact,
                          callback: function($$v) {
                            _vm.$set(_vm.siteInfo, "contact", $$v)
                          },
                          expression: "siteInfo.contact"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    { attrs: { label: _vm.$t("SeaExport.Tel") } },
                    [
                      _c("el-input", {
                        attrs: { no: "phone" },
                        model: {
                          value: _vm.siteInfo.phone,
                          callback: function($$v) {
                            _vm.$set(_vm.siteInfo, "phone", $$v)
                          },
                          expression: "siteInfo.phone"
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "div",
                    {
                      staticStyle: {
                        display: "flex",
                        "align-items": "flex-start"
                      }
                    },
                    [
                      _c("cargo-area", {
                        ref: "area",
                        staticStyle: { display: "inline-block" },
                        attrs: {
                          no: "area",
                          country: _vm.siteInfo.country,
                          province: _vm.siteInfo.province,
                          city: _vm.siteInfo.cityNew,
                          district: _vm.siteInfo.county,
                          town: _vm.siteInfo.town,
                          "province-disabled":
                            _vm.siteInfo.provinceDisabled || false,
                          "city-disabled":
                            _vm.siteInfo.cityNewDisabled || false,
                          "district-disabled":
                            _vm.siteInfo.countyDisabled || false,
                          "town-disabled": _vm.siteInfo.townDisabled || false,
                          "district-label-name": _vm.$t(
                            "CargoMsg.Cargo_CountyDistrict"
                          ),
                          "town-label-name": _vm.$t(
                            "CargoMsg.Cargo_TownStreet"
                          ),
                          "label-width": "100",
                          "select-width": 280,
                          "show-town": true
                        },
                        on: {
                          "update:country": function($event) {
                            return _vm.$set(_vm.siteInfo, "country", $event)
                          },
                          "update:province": function($event) {
                            return _vm.$set(_vm.siteInfo, "province", $event)
                          },
                          "update:city": function($event) {
                            return _vm.$set(_vm.siteInfo, "cityNew", $event)
                          },
                          "update:district": function($event) {
                            return _vm.$set(_vm.siteInfo, "county", $event)
                          },
                          "update:town": function($event) {
                            return _vm.$set(_vm.siteInfo, "town", $event)
                          }
                        }
                      })
                    ],
                    1
                  ),
                  _c(
                    "el-form-item",
                    {
                      attrs: { label: _vm.$t("RailwayExport.DetailedAddress") }
                    },
                    [
                      _c("el-input", {
                        attrs: {
                          disabled: _vm.siteInfo.addressDisabled || false,
                          no: "address"
                        },
                        model: {
                          value: _vm.siteInfo.address,
                          callback: function($$v) {
                            _vm.$set(_vm.siteInfo, "address", $$v)
                          },
                          expression: "siteInfo.address"
                        }
                      })
                    ],
                    1
                  )
                ],
                1
              )
            ],
            1
          ),
          _c(
            "span",
            { attrs: { slot: "footer" }, slot: "footer" },
            [
              !_vm.siteInfo.provinceDisabled &&
              !_vm.siteInfo.cityNewDisabled &&
              !_vm.siteInfo.countyDisabled &&
              !_vm.siteInfo.townDisabled
                ? _c(
                    "el-button",
                    {
                      staticStyle: { height: "32px", margin: "4px 0 0 10px" },
                      attrs: {
                        no: "aiRecognitionRegion",
                        type: "primary",
                        size: "mini"
                      },
                      on: { click: _vm.openAiRegionRecognition }
                    },
                    [
                      _vm._v(
                        _vm._s(_vm.$t("CargoMsg.CargoMsg_AIAddressRecognition"))
                      )
                    ]
                  )
                : _vm._e(),
              _c(
                "el-button",
                {
                  attrs: { no: "save", type: "primary" },
                  on: { click: _vm.saveSub }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.save")))]
              ),
              _c(
                "el-button",
                {
                  attrs: { no: "cancel" },
                  on: {
                    click: function($event) {
                      _vm.innerVisible = false
                    }
                  }
                },
                [_vm._v(_vm._s(_vm.$t("common.btn.cancel")))]
              )
            ],
            1
          )
        ]
      ),
      _c("cargo-ai-recognition-dialog", {
        attrs: {
          visible: _vm.aiRecognitionDialog.visible,
          multimodal: _vm.aiRecognitionDialog.multimodal,
          "prompt-key": _vm.aiRecognitionDialog.promptKey,
          "call-back": _vm.aiRecognitionDialog.callBack,
          title: _vm.$t("CargoMsg.CargoMsg_AIAddressRecognition"),
          placeholder: _vm.aiRecognitionDialog.placeholder
        },
        on: {
          "update:visible": function($event) {
            return _vm.$set(_vm.aiRecognitionDialog, "visible", $event)
          }
        }
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }